import React from 'react';
import { number, shape, string, node, arrayOf } from 'prop-types';
import { LogoCardWithText, CountryFlags } from '../../../..';
import { DetailsWrapper, CountryFlagWrapper } from '../../../Activity.styles';
import { getCountryIdByName } from '../../../../Utils/activities';
export const HighSchoolRead = _ref => {
  let {
    data: {
      details: {
        school,
        subjects = [{}],
        campus,
        location,
        grade
      }
    },
    editButton
  } = _ref;
  const FlagIcon = CountryFlags[getCountryIdByName(location)].icon;
  return /*#__PURE__*/React.createElement(DetailsWrapper, null, editButton, /*#__PURE__*/React.createElement("h1", {
    className: "headline"
  }, "High School"), /*#__PURE__*/React.createElement(LogoCardWithText, {
    title: school.name,
    subtitle: campus.name,
    isSubtitleShortened: true
  }), /*#__PURE__*/React.createElement(CountryFlagWrapper, null, /*#__PURE__*/React.createElement(FlagIcon, null), /*#__PURE__*/React.createElement("div", null, grade ? "".concat(location, " | ").concat(grade) : location)), /*#__PURE__*/React.createElement("div", {
    className: "tags"
  }, subjects.map(index => index.name).join(' • ')));
};
HighSchoolRead.propTypes = {
  data: shape({
    details: shape({
      school: shape({
        id: number,
        name: string
      }).isRequired,
      campus: shape({
        id: number,
        name: string
      }).isRequired,
      subjects: arrayOf(shape({
        id: number,
        name: string
      })),
      grade: string,
      location: string
    }).isRequired
  }).isRequired,
  editButton: node
};
HighSchoolRead.defaultProps = {
  editButton: undefined
};